<script setup lang="ts">

import { ref, computed } from 'vue';
import { DsIcon } from '@demvsystems/design-components';
import MenuModal from '@/application/menu/components/MenuModal.vue';
import MenuHint from '@/application/menu/components/MenuHint.vue';
import { useUnreadHintStore } from '@/application/store/unreadHintStore.ts';
import { UnreadHintType } from '@/api/unreadHint/types.ts';
import { storeToRefs } from 'pinia';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';
import { useUserStore } from '@/user/store/userStore.ts';

const show = ref(false);

const { isMagicLogin } = storeToRefs(useBaseDataStore());
const userStore = useUserStore();
const unreadNews = useUnreadHintStore()
const newsCnt = computed(() => unreadNews[UnreadHintType.News].size);
</script>

<template>
  <button
    v-if="isMagicLogin"
    class="flex flex-row items-center gap-3 hover:bg-gray-100 rounded px-2 py-2.5 mt-1 text-gray-900 cursor-pointer ml-auto"
    @click.prevent="userStore.logUserOutByUser"
  >
    <DsIcon
      name="right-from-bracket"
      variant="light"
      size="lg"
      fixed-width
    />
    <span class="text-base">Abmelden</span>
  </button>
  <button
    v-else
    class="relative flex items-center justify-center p-2 rounded-full hover:cursor-pointer bg-gray-100 text-gray-800 h-8 w-8 md:h-9 md:w-9 ml-auto"
    aria-label="Profil Menü"
    aria-haspopup="dialog"
    :aria-expanded="show"
    @click="show = true"
  >
    <DsIcon name="user" variant="light" />
    <MenuHint :number="newsCnt" class="translate-x-2" />
  </button>
  <Teleport to="#app-page-content">
    <MenuModal :show="show" @close="show = false" />
  </Teleport>
</template>
